<template>
    <div class="right-bar">
        <button @click="closeAll" class="right-bar__toggle button-circle button-circle--better position-absolute" :class="{ 'active': menuRightBarIsOpen }">
            <span class="button-circle__icon i-extend"></span>
        </button>
        <div class="right-bar__panel">
            <ul class="right-bar__list">
                <li @click="menuSettings = !menuSettings"
                    class="right-bar__item right-bar__item--better i-settings"
                    :class="{ 'active': menuSettings}">
                </li>
                <li @click="menuCommunication = !menuCommunication"
                    class="right-bar__item right-bar__item--better i-communication"
                    :class="{ 'active': menuCommunication }">
                </li>
                <li @click="menuSourceCode = !menuSourceCode"
                    class="right-bar__item right-bar__item--better i-source"
                    :class="{ 'active': menuSourceCode }">
                </li>
                <li @click="menuOnline = !menuOnline"
                    class="right-bar__item right-bar__item--better i-online"
                    :class="{ 'active': menuOnline }">
                </li>
                <li @click="menuHelp = !menuHelp"
                    class="right-bar__item right-bar__item--better i-help"
                    :class="{ 'active': menuHelp }">
                </li>
                <li @click="$emit('activejoystick'), menuJoyStick = !menuJoyStick"
                    class="right-bar__item right-bar__item--better i-joy"
                    :class="{ 'active': menuJoyStick}"
                    v-if="showJoyStickSidebarIcon"
                >
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
    import menuMixin from '../../../mixins/menu';
    // import ClickOutside from 'vue-click-outside';

    export default {
        props: {
            showJoyStickSidebarIcon: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        mixins: [
            menuMixin,
        ],
        // directives: {
        //     ClickOutside,
        // },
        data() {
            return {
                menuJoyStick: false,
            };
        },
        methods: {
            closeAll() {
                if (!this.menuRightBarIsOpen) {
                    this.menuSettings = true;
                } else {
                    this.$store.dispatch('menu/closeAll');
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/rightbar/RightBar.vue